import { create } from "zustand"

import type { CitationReview, DraftReviewReport } from "../lib/review"
import { UNVERIFIED_STATUSES, parseReviewReport } from "../lib/review"

interface ReviewState {
  report: DraftReviewReport | null

  setFromJson: (json: string | null | undefined) => void
  /** Apply a /precedent/resolve response for one allegation in place. */
  applyResolve: (allegationId: string, reviews: CitationReview[]) => void
  reset: () => void
}

const initialState = {
  report: null as DraftReviewReport | null,
}

export const useReviewStore = create<ReviewState>((set) => ({
  ...initialState,

  setFromJson: (json) => {
    const parsed = parseReviewReport(json)
    if (parsed) set({ report: parsed })
  },

  applyResolve: (allegationId, reviews) =>
    set((prev) => {
      if (!prev.report) return prev
      const others = prev.report.citation_reviews.filter(
        (c) => c.allegation_id !== allegationId,
      )
      const citation_reviews = [...others, ...reviews]
      return {
        report: {
          ...prev.report,
          citation_reviews,
          unverified_citation_count: citation_reviews.filter((c) =>
            UNVERIFIED_STATUSES.has(c.verification_status),
          ).length,
        },
      }
    }),

  reset: () => set(initialState),
}))
